import { useState } from 'react';
import Button from './ui/Button';

export default function ContactForm({ title = "Kontakt os for et uforpligtende tilbud på kørsel" }) {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="p-0">
      <h3 className="text-2xl font-black text-slate-900 mb-8">{title}</h3>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Honeypot */}
        <div className="sr-only absolute" aria-hidden="true">
          <label htmlFor="website_url">Website URL</label>
          <input type="text" id="website_url" name="website_url" tabIndex="-1" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Navn</label>
            <input
              type="text"
              id="name"
              name="name"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all"
              placeholder="Dit navn"
            />
          </div>
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all"
              placeholder="Dit telefonnummer"
            />
          </div>
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all"
            placeholder="din@email.dk"
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Besked</label>
          <textarea
            id="message"
            name="message"
            rows="4"
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all"
            placeholder="Hvordan kan vi hjælpe dig?"
          ></textarea>
        </div>

        <Button 
          type="submit" 
          className="w-full"
          disabled={status === 'sending'}
        >
          {status === 'sending' ? 'Sender...' : 'Send besked'}
        </Button>

        {status === 'success' && (
          <p className="text-green-600 text-sm font-medium mt-2">Tak for din besked! Vi vender tilbage hurtigst muligt.</p>
        )}
        {status === 'error' && (
          <p className="text-red-600 text-sm font-medium mt-2">Der skete en fejl. Prøv venligst igen eller ring til os.</p>
        )}
      </form>
    </div>
  );
}
